<template>
    <div v-loading="loading">
        <div class="search_bread" v-if="keyword">
            <span>搜索结果:</span>
            <span class="keyword">'{{ keyword }}'</span>
        </div>

        <!-- 排序筛选区 -->
        <div class="filters">
            <div class="sort">
                <!-- <div class="item" @click="changeSort('site_id')">
                    <div class="item-name">综合</div>
                    <i
                        v-if="filters.order === 'site_id' && filters.sort === 'desc'"
                        class="el-icon-arrow-down el-icon--down"
                    />
                    <i v-else class="el-icon-arrow-up el-icon--up" />
                </div>
                <div class="item" @click="changeSort('shop_sales')">
                    <div class="item-name">销量</div>
                    <i
                        v-if="filters.order === 'shop_sales' && filters.sort === 'desc'"
                        class="el-icon-arrow-down el-icon--down"
                    />
                    <i v-else class="el-icon-arrow-up el-icon--up" />
                </div>
                <div class="item" @click="changeSort('shop_desccredit')">
                    <div class="item-name">信用</div>
                    <i
                        v-if="filters.order === 'shop_desccredit' && filters.sort === 'desc'"
                        class="el-icon-arrow-down el-icon--down"
                    />
                    <i v-else class="el-icon-arrow-up el-icon--up" />
                </div> -->
            </div>
            <div class="search">
                <el-input
                    placeholder="搜索 公司"
                    v-model="keyword"
                    maxlength="50"
                    class="input-with-select"
                    size="medium"
                    clearable
                >
                    <el-button slot="append" icon="el-icon-search" @click="getShopList"></el-button>
                </el-input>
            </div>
        </div>

        <!-- 店铺列表 -->
        <div class="shop-wrap" v-if="shopList.length">
            <div
                class="shop-item"
                v-for="item in shopList"
                :key="item.id"
                @click="toDetail(item.site_id)"
            >
				<div class="info">
					<el-image
						class="logo"
						fit="contain"
					    :src="$img(item.logo || defaultShopImage)"
					    @error="item.logo = defaultShopImage"
					/>
					<div class="name">{{ item.site_name }}</div>
				</div>
				<div class="main">
					<p><span>主营：</span>{{ item.seo_keywords || '暂无'}}</p>
				</div>
				<p class="c"><span>简介：</span>{{ item.seo_description||'暂无' }}</p>
				<!-- <div class="content">
					<div><span>地址:</span>{{item.full_address||'暂无'}}</div>
					<div><span>所在地:</span>{{item.province_name}}{{item.city_name||'暂无'}}</div>
					<div><span>联系方式:</span>{{item.telephone||'暂无'}}</div>
				</div> -->
				<div class="sku-list">
					<div class="goods-info" v-if="item.sku.length">
						<div class="item" v-for="(sku_item, index) in item.sku" :key="'sku-'+sku_item.goods_id+sku_item.sku_id" @click="$router.pushToTab({ path: '/sku-' + sku_item.sku_id })">
							<el-image class="img-wrap" :src="$img(sku_item.sku_image, { size: 'mid' })" @error="imageError(index)" />
						
							<div class="goods-name">{{ sku_item.goods_name }}</div>
							<div class="price-wrap">
								<div class="price price-color">
									<p>￥</p>
									{{ sku_item.discount_price }}
								</div>
								<div class="market-price">￥{{ sku_item.market_price }}</div>
							</div>
							<div class="promotion_type" v-if="sku_item.promotion_type == 1">限时折扣</div>
						</div>
					</div>
					
				</div>
                
            </div>
        </div>
        <div v-else class="empty">
            <div class="ns-text-align">没有找到您想要的店铺。换个条件试试吧</div>
        </div>
        <div class="pager">
            <el-pagination
                background
                :pager-count="5"
                :total="total"
                prev-text="上一页"
                next-text="下一页"
                :current-page.sync="currentPage"
                :page-size.sync="pageSize"
                @size-change="handlePageSizeChange"
                @current-change="handleCurrentPageChange"
                hide-on-single-page
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import BreadCrumbs from "@/components/BreadCrumbs"
import { shopList } from "@/api/shop"
export default {
    data: () => {
        return {
            shopList: [], // 店铺列表
            total: 0,
            keyword: "",
            currentPage: 1,
            pageSize: 12,
            loading: true,
            filters: {
                // order: "seo_description",
                // sort: "desc"
            }
        }
    },
    components: { BreadCrumbs },
    created() {
        this.keyword = this.$route.query.keyword || ""
        this.getShopList()
    },
    computed: {
        ...mapGetters(["defaultGoodsImage", "defaultShopImage"])
    },
    methods: {
        getShopList() {
            const params = {
                keyword: this.keyword,
                page: this.currentPage,
                page_size: this.pageSize,
				include:'sku',
				order_by:'is_recommend desc,sort desc,sub_num desc,seo_description desc,seo_keywords desc',
                ...this.filters
            }
            shopList(params || {})
                .then(res => {
                    const { count, page_count, list } = res.data
                    // console.log(res)
                    this.total = count
                    this.shopList = list
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
        },

        handlePageSizeChange(size) {
            this.pageSize = size
            this.getShopList()
        },
        handleCurrentPageChange(page) {
            this.currentPage = page
            this.getShopList()
        },
        changeSort(type) {
            this.filters.order = type
            if (this.filters.order === type) {
                this.$set(this.filters, "sort", this.filters.sort === "desc" ? "asc" : "desc")
            } else {
                this.$set(this.filters, "order", type)
                this.$set(this.filters, "sort", "desc")
            }
            this.getShopList()
        },
        toDetail(site_id) {
            this.$router.pushToTab({
                path: "/shop-" + site_id
            })
        }
    },
    watch: {
        $route: function(curr) {
            if (this.keyword !== curr.query.keyword) {
                this.currentPage = 1
                this.keyword = curr.query.keyword
                this.getShopList()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.search_bread {
    display: inline-block;
    font-size: 14px;
    margin: 0px auto;
    width: 100%;
    padding: 10px;
}

.filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .sort {
        display: flex;
        align-items: center;
        border: 1px solid #f1f1f1;

        .item {
            display: flex;
            align-items: center;
            padding: 5px 15px;
            border-right: 1px solid #f1f1f1;
            cursor: pointer;
            &:last-child {
                border: none;
            }
            &:hover {
                background: $base-color;
                color: #fff;
            }
        }
    }
}

.shop-wrap {
    display: flex;
    flex-wrap: wrap;
    .shop-item {
        border: 1px solid #f1f1f1;
        padding: 15px;
        padding-bottom: 0;
        position: relative;
        margin-right: 10px;
        margin-top: 10px;
        cursor: pointer;
		width: 600px;
		box-sizing: border-box;
        &:hover {
            border: 1px solid $base-color;
        }
        &:nth-child(2n) {
            margin-right: initial;
        }
		.info{
			display: flex;
			flex-wrap: wrap;
			// background-color: $base-color;
			// color: #fff;
			.logo{
				display: inline-block;
				background-color: #fff;
				width: 60px;
				height: 60px;
				border-radius: 50px;
				// border: 1px solid $base-color;
			}
			.name{
				flex:1;
				line-height: 60px;
				padding-left: 10px;
			}
		}
		.main{
			p{
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
				text-indent: 2em;
				text-align: justify;
				// height: 100px;
				// margin: 10px 0;
			}
		}
		p.c{
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
			overflow: hidden;
			text-indent: 2em;
			text-align: justify;
			height: 75px;
			// margin: 10px 0;
		}
		.content{
			display: block;
			padding: 10px 0;
			// background: #f2f2f2;
			div{
				display: block;
				overflow: hidden;
			}
			span{
				display: block;
				width: 75px;
				float: left;
			}
		}
		
    }
}

.sku-list{
	.goods-info {
		margin-top: 5px;
		display: flex;
		flex-wrap: wrap;
	
		.item {
			width: 182px;
			margin: 10px 10px 0 0;
			border: 1px solid #eeeeee;
			padding: 10px;
			position: relative;
			box-sizing: border-box;
			
			&:nth-child(3n) {
				margin-right: initial !important;
			}
	
			&:hover {
				border: 1px solid $base-color;
			}
	
			.img-wrap {
				width: 160px;
				height: 160px;
				cursor: pointer;
			}
	
			.goods-name {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				cursor: pointer;
	
				&:hover {
					color: $base-color;
				}
			}
	
			.price-wrap {
				display: flex;
	
				.price {
					display: flex;
					color: $base-color;
					font-size: $ns-font-size-lg;
	
					p {
						font-size: $ns-font-size-base;
						display: flex;
						align-items: flex-end;
					}
				}
	
				.market-price {
					color: #838383;
					text-decoration: line-through;
					margin-left: 15px;
				}
			}
	
			.promotion_type {
				position: absolute;
				top: 0;
				right: 0;
				color: #ffffff;
				background: $base-color;
				border-bottom-left-radius: 10px;
				padding: 3px 8px;
				line-height: 1;
				font-size: $ns-font-size-sm;
			}
		}
	}
}

.pager {
    text-align: center;
    margin-top: 30px;
}
.empty {
    line-height: 500px;
}
</style>
